/**
 * @link https://date-fns.org/v1.28.5/docs/format
 */
import format from 'date-fns/format';
import endOfDay from 'date-fns/end_of_day';

export const TIME_FORMAT = 'h:mm A';
export const DATE_FORMAT = {
	long: 'ddd Do of MMM, YYYY',
	short: 'ddd Do of MMM, YYYY',
	date_time: {
		long: 'dd Do of MMM, YYYY at HH:mm',
		short: 'D MMM YY@HH:mm'
	},
	tiny: 'dd D MMM YY',
	data_base: 'YYYY-MM-DD HH:mm:ss',//2018-04-17 11:14:26
	data_base_day: 'YYYY-MM-DD',
	url_date: 'MMM-YY',
	year_long: 'YYYY',
	year: {
		long: 'YYYY',
		short: 'YY'
	},
	month: {
		name: {
			long: 'MMMM',//January, February, ..., December
			short: 'MMM' //Jan, Feb, ..., Dec
		},
		num: {
			long: 'Do', //1st
			short: 'D' // 1
		}
	},
	day: {
		name: {
			long: 'dddd',
			short: 'ddd'
		},
		num: {
			long: 'Do', //1st
			short: 'D' // 1
		}
	}
};

/**
 *
 * @param formatString
 * @returns {*}
 */
function setTimeFormat(formatString) {
	if (!formatString) {
		return TIME_FORMAT;
	}
	return formatString;
}

/**
 *
 * @param formatString
 * @returns {*}
 */
function setDateFormat(formatString) {
	if (!formatString) {
		return DATE_FORMAT.short;
	}
	if (formatString in DATE_FORMAT) {
		return DATE_FORMAT[formatString];
	}
	return formatString;
}

export function santiseDateString(dateString) {
	return dateString.replace(/-/g, '/')
}

/**
 *
 * @param string
 * @returns {Date}
 */
export function setDate(string) {
	if (typeof string == 'object' && string !== null) {
		return string;
	}
	if (typeof string !== 'undefined' && string !== null) {
		// console.log('string',string,'new Date(string)',new Date(string));
		return new Date(santiseDateString(string));
	}
	else {
		// console.log(' new Date()', new Date());
		return new Date();
	}

}

/**
 *
 * @param string
 * @param formatString
 * @param returnObject
 * @returns {string|object}
 */
export function getDate(string, formatString, returnObject) {
	let date = format(setDate(string), setDateFormat(formatString));
	// console.log('date',date);
	if (returnObject) {
		let split = date.split(' ');
		return {
			day: split[0],
			month: split[1],
			year: split[2]
		}
	}
	return date;

}

/**
 *
 * @param string
 * @param formatString
 * @returns {string|object}
 */
export function getTime(string, formatString) {
	return format(setDate(string), setTimeFormat(formatString));
}

/**
 *
 * @param string
 * @param long
 * @returns {string|object}
 */
export function getYear(string, long) {
	return format(setDate(string), (long) ? DATE_FORMAT.year.long : DATE_FORMAT.year.short);
}

/**
 *
 * @param string
 * @param formatString
 * @returns {string|object}
 */
export function getMonth(string, formatString) {

	let type = DATE_FORMAT.month.num.short;
	if (typeof formatString !== 'undefined' && formatString !== null) {
		if (formatString === 'name_long') {
			type = DATE_FORMAT.month.name.long;
		}
		else if (formatString === 'name_short') {
			type = DATE_FORMAT.month.name.short;
		}
		else if (formatString === 'num_long') {
			type = DATE_FORMAT.month.num.long;
		}
	}

	return format(setDate(string), type);
}

/**
 *
 * @param string
 * @param formatString
 * @returns {string|object}
 */
export function getDay(string, formatString) {

	let type = DATE_FORMAT.day.num.short;
	if (typeof formatString !== 'undefined' && formatString !== null) {
		if (formatString === 'name_long') {
			type = DATE_FORMAT.day.name.long;
		}
		else if (formatString === 'name_short') {
			type = DATE_FORMAT.day.name.short;
		}
		else if (formatString === 'num_long') {
			type = DATE_FORMAT.day.num.long;
		}
	}

	return format(setDate(string), type);
}


export function getEndOfDay(string, formatString, returnObject){

	let end = endOfDay(string);

	return getDate(end, formatString, returnObject);


}
export function datePassed() {

}



// WEBPACK FOOTER //
// ./app/Shared/Resources/Assets/js/helpers/format.date.js